import { _ } from "libs";

import React, { FC, useState, useLayoutEffect } from "react";
import { RouteChildrenProps } from "react-router";
import Modal from "../components/modal";
import { SimpleLoginBox } from "./login";
import { loggedIn, getClubs } from "../actions";
import { Club } from "../types";
import Loader from "../components/loader";
import ClubItemMedium from "../components/items/club/medium";
import NavbarWidget from "../components/navbarWidget";
import { SimpleRegisterBox } from "./register";
import { Link } from "react-router-dom";
import { parseHashArray } from "../libs/parseHashArray";

const ClubsWidgetPage: FC<RouteChildrenProps<any>> = (props: RouteChildrenProps<any>) => {
	const [showModal, setShowModal] = useState(false);
	const [showRegistrationModal, setShowRegistrationModal] = useState(false);
	const [clubs, setClubs] = useState([] as Club[]);
	const [loading, setLoading] = useState(true);

	const { clubIds } = parseHashArray(props.location.hash);

	useLayoutEffect(() => {
		getClubs(clubIds).then(clubs => {
			setClubs(clubs);
			setLoading(false);
		});
	}, []);

	const openModal = () => {
		setShowModal(true);
	};

	const closeModal = () => {
		setShowModal(false);
	};

	const openRegistrationModal = () => {
		setShowRegistrationModal(true);
	};

	const closeRegistrationModal = () => {
		setShowRegistrationModal(false);
	};

	return (
		<div id="app" data-page="standalone">
			<div className="layout">
				<NavbarWidget
					authenticated={loggedIn()}
					canGoBack={false}
					onLoginButtonClicked={openModal}
					onRegisterButtonClicked={openRegistrationModal}
				/>
				<main className="main">
					<div className="wrap m720">
						{loading ? (
							<Loader />
						) : (
							<div className="table largeClubs">
								{clubs &&
									clubs.map(club => {
										return (
											<Link
												className="cell clickable capsule disclosureIndicator"
												key={club.clubInfo.clubId}
												//onClick={onClick.bind(null, club.clubInfo.clubId)}
												to={{
													pathname: `club/${club.clubInfo.clubId}/widget`,
													// keep widgetMode / parentOrigin / utm params for the single-club widget page
													search: props.location.search,
													hash: props.location.hash,
												}}
											>
												<ClubItemMedium
													name={club.clubInfo.name}
													meta={club.clubInfo.address1}
													photoUrl={club.clubInfo.photoUrl}
												/>
											</Link>
										);
									})}
							</div>
						)}
					</div>
				</main>
				{showModal && !loggedIn() && (
					<Modal title={_("loginPage.heading")} onCloseClicked={closeModal}>
						<SimpleLoginBox destination={props.match.url} />
					</Modal>
				)}

				{showRegistrationModal && !loggedIn() && (
					<Modal title={_("registerPage.heading")} onCloseClicked={closeRegistrationModal}>
						<SimpleRegisterBox destination={props.match.url} />
					</Modal>
				)}
			</div>
		</div>
	);
};

export default ClubsWidgetPage;
